import { Injectable } from "@angular/core";
import { Observable } from 'rxjs/Observable';
import { Http, Response } from '@angular/http';
import { Headers, RequestOptions } from '@angular/http';

import { BaseWebService } from "../shared/services/base-web.service";
import 'rxjs/add/observable/throw';

@Injectable()
export class DocusignService {
    constructor(
        private _baseWebService: BaseWebService
    ){}

    // sends docusign auth code
    sendDocuSignAuth = (code: any): Observable<any> => {
        const data: any = {};
        data.body = code;
        return this._baseWebService.request("v1/docusign_auth/", "post", data)
            .map((res: any) => res)
            .catch(this.handleError);

    }

    /**
     * function for login error.
     * @param  {Response|any} error error response.
     */
    handleError(error: Response | any) {
        return Observable.throw(error);
    }
}